var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteSelect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "36px",
    viewBox: "0 0 158 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-722.000000, -218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(722.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F8F8F8",
    x: 0,
    y: 0,
    width: 158,
    height: 29,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "cursor-pointer",
    transform: "translate(121.000000, 18.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3554159,8.75458462 L4.80708193,7.92307692 L4.80708193,4.23076923 C4.80708193,3.55089231 4.26916946,3 3.60531145,3 C2.94145343,3 2.40354096,3.55089231 2.40354096,4.23076923 L2.40354096,11.3692308 L1.44212458,11.3692308 L1.44212458,9.4 L0.961416386,9.4 C0.430233833,9.4 0,9.84061538 0,10.3846154 L0,13.3384615 C0,15.4307692 2.43911337,16.5079385 2.43911337,17.7692308 L10.9606275,17.7692308 L11.9773253,11.0024615 C12.1398047,9.92184615 11.4115318,8.91310769 10.3554159,8.75458462 Z M5.28779012,15.3076923 L4.32637374,15.3076923 L4.32637374,10.8769231 L5.28779012,10.8769231 L5.28779012,15.3076923 Z M7.21062289,15.3076923 L6.24920651,15.3076923 L6.24920651,10.8769231 L7.21062289,10.8769231 L7.21062289,15.3076923 Z M9.13345567,15.3076923 L8.17203928,15.3076923 L8.17203928,10.8769231 L9.13345567,10.8769231 L9.13345567,15.3076923 Z",
    id: "Shape",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8181818,6.90909091 C14.0472137,6.90909091 14.2668472,6.81801991 14.4287727,6.65604545 L18.7469545,2.33786364 C19.0742487,1.99899096 19.069568,1.46033587 18.7364342,1.12720214 C18.4033005,0.794068404 17.8646454,0.789387637 17.5257727,1.11668182 L13.2075909,5.43486364 C12.9606704,5.68185867 12.8868174,6.0532589 13.0204599,6.37592894 C13.1541024,6.69859898 13.4689308,6.90901634 13.8181818,6.90909091 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1537727,6.01954545 C10.2224408,6.03653593 10.2928979,6.04523434 10.3636364,6.04545455 C10.7596979,6.04494899 11.1046534,5.77510765 11.2005,5.39081818 L12.0641364,1.93627273 C12.1526579,1.63235669 12.0678212,1.30436555 11.8430412,1.08148671 C11.6182612,0.858607879 11.2895613,0.776560046 10.9864081,0.867659783 C10.6832549,0.958759519 10.4542319,1.20840713 10.3895455,1.51827273 L9.52590909,4.97281818 C9.41056543,5.43519572 9.6915413,5.90361767 10.1537727,6.01954545 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9265,7.79863636 L14.4719545,8.66227273 C14.048984,8.76827913 13.7713861,9.17295631 13.8247686,9.60572846 C13.8781512,10.0385006 14.2457661,10.3635906 14.6818182,10.3636364 C14.7528457,10.3634853 14.8235968,10.3547864 14.8925455,10.3377273 L18.3470909,9.47409091 C18.8065967,9.35548379 19.0843158,8.88833451 18.9689932,8.42799341 C18.8536706,7.96765231 18.3885166,7.68660423 17.9273636,7.79863636 L17.9265,7.79863636 Z",
    id: "Path",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#D8D8D8",
    transform: "translate(145.000000, 15.500000) scale(1, -1) translate(-145.000000, -15.500000) ",
    points: "145 14 147 17 143 17"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F0F0F0",
    x: 10,
    y: 11,
    width: 101,
    height: 7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteSelect);
export default __webpack_public_path__ + "static/media/site-select.f4f9e2816600ed352b91afb430db7858.svg";
export { ForwardRef as ReactComponent };